import BrandIconURL from '../assets/img/federated_fiducial.png';
import AppIconURL from '../assets/img/federated_fiducial.png';

export const DOMAIN_NAME = 'FIDUCIAL_FEDERATED';
export const API_DOMAIN_NAME = DOMAIN_NAME;

export const BRAND_NAME = 'Federated Fiducial';
export const PRODUCT_NAME = 'Client Portal';
export const APP_MENU_ICON_URL = BrandIconURL;
export const APP_EXPLORE_ICON_URL = AppIconURL;

export const LOGIN_BRAND_LOGO = {
    width: '240px'
};

export const PORTAL_URL = process.env.REACT_APP_FEDERATED_PORTAL_URL ?? 'FEDERATED_URL';

export const LOGO_SIZE = '96px'
export const APP_MENU_ICON_PROPS = {
    minHeight: 110,
    maxHeight: 110,
    width: '100%',
    marginLeft: 0,
    backgroundPosition: 'center',
    backgroundSize: 128
};

export const APP_EXPLORE_LOGO_STYLE = {};
export const APP_EXPLORE_ICON_CONF = {
    backgroundImage: `url(${APP_EXPLORE_ICON_URL})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 240,
    width: 240
};

export default {
    DOMAIN_NAME,
    BRAND_NAME,
    PRODUCT_NAME,
    APP_MENU_ICON_URL,
    APP_MENU_ICON_PROPS,
    LOGIN_BRAND_LOGO,
    PORTAL_URL,
    APP_EXPLORE_ICON_URL,
    APP_EXPLORE_ICON_CONF,
};
